import { render } from "./DeleteLocation.vue?vue&type=template&id=523bc573&scoped=true"
import script from "./DeleteLocation.vue?vue&type=script&lang=js"
export * from "./DeleteLocation.vue?vue&type=script&lang=js"

import "./DeleteLocation.vue?vue&type=style&index=0&id=523bc573&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523bc573"]])

export default __exports__